// extracted by mini-css-extract-plugin
export default {"root":"_8aVvt","align-items-center":"aG0mc","alignItemsCenter":"aG0mc"};